export enum DATA_QA {
  ROOT = 'time-select',
}
